var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.027a1 1 0 010 2H2v18h18V12.026a1 1 0 012 0v11a1 1 0 01-1 1H1a1 1 0 01-1-1v-20a1 1 0 011-1h11zM23.108 1.01c1.126 1.2.91 2.96.882 3.157-.007.045-.03.08-.042.123-.015.055-.029.108-.053.16a.996.996 0 01-.13.194l-.027.045-.03.043-10 10c-.018.017-.04.022-.058.038-.05.044-.107.076-.166.11a.958.958 0 01-.18.086l-.03.015-.03.014-4 1a1 1 0 01-1.236-1.083l.022-.128 1-4.001c.005-.023.022-.04.03-.062a.97.97 0 01.086-.181.969.969 0 01.108-.164l.02-.03.02-.028 10-10c.028-.03.065-.04.097-.065a.935.935 0 01.17-.112.917.917 0 01.187-.067c.038-.01.07-.033.11-.04.212-.03 2.098-.26 3.25.976zm-2.67.99l-9.535 9.536-.528 2.115 2.114-.53 9.535-9.534c-.003-.361-.077-.891-.377-1.211-.283-.304-.834-.374-1.209-.375z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconEdit;